module.exports = __webpack_public_path__ + "images/emails/digest/i-domain-a0c2ba61.png";